import { CreditType as CreditTypeConst, ProvinceCodes } from '@/constants';

import { Region } from './ui';

interface FieldOfStudy {
  isTechnical: boolean;
  fieldOfStudyId: string;
  name?: string;
  credit: number;
}

export const CPDDeliveryMethodOptions = [
  'Please Select',
  'Webinar',
  'Conference',
  'E-Learning',
  'Instruction / Speaking',
  'Committees',
  'Research and Publications',
] as const;

export const CPDProviderOptions = [
  'Please Select',
  'CFI',
  'CPA BC',
  'CPA Canada',
  'CPA Ontario',
  'CPD Formula',
  'Learnsignal',
  'Other',
] as const;

export const CPEDeliveryMethodOptions = [
  'Please Select',
  'Self-Study',
  'Group-Live',
  'Group Internet Based',
  'Publication',
] as const;

export const CPEProviderOptions = [
  'Please Select',
  'AICPA',
  'Becker',
  'Surgent CPE',
  'Thomspon Reuters',
  'Other',
] as const;

export type Certificate = {
  certificateId: number;
  title: string;
  name: string;
  description: string;
  credit: number;
  ethicsCredit: number;
  technicalCredit: number;
  dateCompleted: string;
  type: CreditType;
  fileName?: string;
  fileSize?: number;
  fileUri?: string;
  episodeId: string;
  region: Region;
  fieldsOfStudy?: FieldOfStudy[];
  deliveryMethod?:
    | (typeof CPDDeliveryMethodOptions)[number]
    | (typeof CPEDeliveryMethodOptions)[number];
  provider?: string;
  otherProvider?: string;
  location?: string;
};

export type CreditType = (typeof CreditTypeConst)[keyof typeof CreditTypeConst];

export type Province = keyof typeof ProvinceCodes;

export type TriennialSummary = {
  region: Province;
  designationYear: number;
  triennialRequirement: number;
  triennialEthicsRequirement: number;
  yearlySummary: YearlySummary[];
} | null;

export type YearlySummary = {
  baseYear: number;
  dateStart: string;
  dateEnd: string;
  completed: number;
  ethics: number;
  lumiqHours: number;
  lumiqEthicsHours: number;
};

export interface DateRange {
  fromDate: string;
  toDate: string;
}

type CustomCertificateInputBase = {
  title: string;
  credit: string;
  dateCompleted: string;
  provider: string;
  otherProvider?: string;
  isEthics: boolean;
  description?: string;
  file?: File;
  originalFile?: { name: string; size: number; uri: string };
};

export type CustomCertificateInput =
  | (CustomCertificateInputBase & {
      complianceType: 'CPD';
      deliveryMethod: (typeof CPDDeliveryMethodOptions)[number];
    })
  | (CustomCertificateInputBase & {
      complianceType: 'CPE';
      location: string;
      deliveryMethod: (typeof CPEDeliveryMethodOptions)[number];
      fieldOfStudy: {
        fieldOfStudyId: string;
        name: string;
      }[];
    });
